import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { toKebabCase } from '../../app.helper';
import { AppStore } from '../../app.store';
import { Actions } from '../../features/roles-management/enum';
import { AuthStore } from '../../features/login/store/auth.store';
import { PATH } from '../enums';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, take, map, catchError, of } from 'rxjs';
import { IClientConfig } from '../../../shared/interfaces';

export const RolesGuard: CanActivateFn = (route, state) => {
  const appStore = inject(AppStore);
  const authStore = inject(AuthStore);
  const router = inject(Router);

  const config$ = toObservable(appStore.clientConfig);

  return config$.pipe(
    filter(Boolean),
    take(1),
    map((clientConfig: IClientConfig) => {
      const desktopModules = clientConfig.modules[0]?.desktop || [];
      const allowedRoutes = desktopModules.map((m) => toKebabCase(m.name));

      const requestedPath =
        route.parent?.routeConfig?.path ||
        route.routeConfig?.path ||
        state.url.split('/')[1].split('?')[0];

      if (!allowedRoutes.includes(requestedPath)) {
        return false;
      }

      const moduleConfig = desktopModules.find(
        (m) => toKebabCase(m.name) === requestedPath,
      );
      if (!moduleConfig) {
        return false;
      }

      const user = authStore.currentUser();
      const perms = user?.userRole?.permissions?.desktop || [];

      const hasRead = perms
        .find((p) => p.resource === moduleConfig.name)
        ?.actions.includes(Actions.READ);

      if (hasRead) {
        return true;
      }

      console.error('not allowed', requestedPath, allowedRoutes);

      router.navigate([PATH.REPORTS]);
      return false;
    }),
    catchError((error) => {
      console.error('RolesGuard: Error loading client configuration.', error);
      router.navigate([PATH.REPORTS]);
      return of(false);
    }),
  );
};
